module.exports = __webpack_public_path__ + "img/tablet.9baf71f6.svg";